import { Dispatch, SetStateAction, useContext, useState } from 'react'
import { HttpVerb } from '../../../types/api-types'
import useToastMessage from '../../hooks/use-toast-message'
import fetchApi from '../../services/api'
import { UserContext } from '../../state/user-state'
import { ERROR_MESSAGES } from '../errors/messages'
import { useNavigate } from 'react-router-dom'
import { Button, Modal } from '@msaf/core-react'
import handleAPIError from '../errors/handler'

interface DeleteWellModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  wellId: string
}

export default function DeleteWellModal({ isOpen, setIsOpen, wellId }: DeleteWellModalProps) {
  const { state } = useContext(UserContext)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isDeleteSuccess, setIsDeleteSuccess] = useState(false)
  const navigate = useNavigate()

  const handleDelete = async () => {
    const url = `wells/${wellId}/delete`
    try {
      await fetchApi({ url, token: state.token, method: HttpVerb.DELETE, auth_method: state.auth_method })
      setIsDeleteSuccess(true)
      navigate(`/wells`, { state: { isProgrammaticTransition: true } })
    } catch (error: any) {
      setIsDeleteError(true)
      handleAPIError(error, { componentStack: 'DeleteWellModal' }, state)
    }

    setIsOpen(false)
  }

  useToastMessage({
    error: isDeleteError,
    errorMessage: ERROR_MESSAGES.DELETE_FAILED,
    isSuccess: isDeleteSuccess,
    successMessage: 'Well record deleted',
    isError: isDeleteError,
  })

  return (
    <Modal
      isOpen={isOpen}
      heading='Confirm delete well record'
      body='Are you sure you want to delete this well record?'
      contentLabel='Delete well confirmation modal'
      onRequestClose={() => setIsOpen(false)}
      buttons={
        <>
          <Button buttonStyle='primary' label='Delete' onClick={() => handleDelete()} />
          <Button buttonStyle='secondary' label='Cancel' onClick={() => setIsOpen(false)} />
        </>
      }
    />
  )
}
